import client from 'data/client';
import { HistoryPayload, HistoryQueryParams } from 'data/types/history';
import { normalizeHistory } from 'model/history';

const getHistory = async ({
  dateStart,
  dateEnd,
  search,
  brandId,
  previousPageId,
}: HistoryQueryParams) => {
  const queryParams = new URLSearchParams();

  if (dateStart) {
    queryParams.append('dateStart', dateStart);
  }

  if (dateEnd) {
    queryParams.append('dateEnd', dateEnd);
  }

  if (search) {
    queryParams.append('search', search);
  }

  if (brandId) {
    queryParams.append('brandId', brandId);
  }

  if (previousPageId) {
    queryParams.append('previousPageId', previousPageId);
  }

  const response = await client.get<HistoryPayload>(
    `/orders/history?${queryParams.toString()}`,
  );

  return normalizeHistory(response.data);
};

export default getHistory;
